import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Modal, TextInput, Dropzone, DatePicker, Select, Button } from 'advenio-components'
import { Form } from 'formsy-react-2'
import moment from 'moment'

const InputsRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 8px;
  flex-wrap: wrap;
`
const InputContainer = styled.div`
  margin: 0 8px;
  display: ${({ open }) => (open ? 'flex' : 'none')}
  flex-basis: 30%;
`
const DropzoneContainer = styled.div`
  width: 100%;
  height: 200px;
  margin: 16px 0;
`
const ButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 16px 0;
`

const initialCards = [{ header: '', options: [{ id: 0, value: '', label: '' }] }]

class AddDepositModal extends Component {
  state = {
    file: null,
    showCardSelect: false,
    cardsOptions: initialCards,
    paymentMethods: [{ id: 0, value: '', label: '' }],
  }

  componentWillMount = () => {
    const { paymentTypes, open } = this.props

    if (paymentTypes && paymentTypes.length) {
      const paymentMethods = paymentTypes.map(type => ({
        id: type.id,
        label: type.type.name,
        value: type.id,
      }))
      const paymentMethodsWithoutCard = paymentMethods.filter(
        method => method.label.indexOf('Tarjeta') < 0 && method.label.indexOf('Card') < 0,
      )

      this.setState({ paymentMethods: paymentMethodsWithoutCard })
    }
  }

  handleSubmit = (data) => {
    const { sendDeposit, company: { id, centers, country } } = this.props
    const date = moment(data.date, 'YYYY-MM-DD')
      .hour(moment().hour())
      .minute(moment().minute())
      .second(moment().second())
      .format('YYYY-MM-DD HH:mm:SS')
    const newForm = new FormData()

    newForm.append('receipt', this.state.file)
    newForm.append('type', 'deposit')
    newForm.append('company_id', id)
    newForm.append('date', date)
    newForm.append('method_id', data.method_id)
    newForm.append('total', data.total)
    newForm.append('country_id', country.id)
    newForm.append('center_id', centers[0].id)

    if (data.card_id) {
      newForm.append('card_id', data.card_id)
    }

    sendDeposit(id, newForm)
  }

  handleFileDrop = (file) => {
    const { onFileDrop } = this.props

    this.setState({ file }, () => onFileDrop && onFileDrop(file))
  }

  handleFormChange = (e) => {
    const { cards, paymentTypes } = this.props
    const { value } = e.target
    const { showCardSelect } = this.state
    const paymentType = paymentTypes.find(type => type.id === Number(value))
    this.setState({
      showCardSelect:
        (paymentType.type.name.indexOf('Tarjeta') >= 0 || paymentType.type.name.indexOf('Card') >= 0) &&
        cards.authorized.length > 0,
    })
  }

  render() {
    const { open, onClose, sending, country } = this.props
    const { showCardSelect, cardsOptions, paymentMethods } = this.state

    return (
      <Modal
        isOpened={open}
        onClose={onClose}
        headerTitle="Agregar Depósito"
        statePath="companyAccount"
        actionType="create"
        typePrefix="COMPANY_ACCOUNT"
      >
        <Form
          onSubmit={this.handleSubmit}
          ref={(form) => {
            this.form = form
          }}
        >
          <InputsRow>
            <InputContainer open>
              <DatePicker name="date" label="Fecha" value={moment().format('YYYY-MM-DD')} disableAfterToday />
            </InputContainer>
            <InputContainer open>
              <TextInput
                name="total"
                label="Monto"
                prefix={country && country.currency_symbol}
                // suffix={country && country.currency_code}
                type="number"
              />
            </InputContainer>
            <InputContainer open>
              <Select
                name="method_id"
                label="Tipo de Pago"
                // onChangeCallback={this.handleFormChange}
                options={paymentMethods}
              />
            </InputContainer>
          </InputsRow>
          <DropzoneContainer>
            <Dropzone
              onDrop={this.handleFileDrop}
              label="Da click o arrastra un documento aquí"
              onDragLabel="Soltar Documento"
              ref={(dropzone) => {
                this.dropzone = dropzone
              }}
            />
          </DropzoneContainer>
          <ButtonsRow>
            <Button onClick={onClose}>Cancelar</Button>
            <Button primary type="submit" loading={sending}>
              Agregar
            </Button>
          </ButtonsRow>
        </Form>
      </Modal>
    )
  }
}
const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({})
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddDepositModal)



// WEBPACK FOOTER //
// ./src/Containers/CompanyAccount/AddDepositModal.jsx